// Reconciliation resolve call. True-resolve takes a repair action — adopt Healthie or push
// CC. The published api-client's resolveDrift doesn't yet take the action arg (next batched SDK
// release), so we POST directly with the HttpClient bearer-auth contract until then.
import { API_ORIGIN } from "../config";

export type ResolveAction = "accept_healthie" | "push_cc";

type GetToken = (() => Promise<string | null>) | undefined;

export async function resolveDrift(
  getToken: GetToken,
  id: string,
  action: ResolveAction,
): Promise<unknown> {
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  const token = getToken ? await getToken() : null;
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const res = await fetch(`${API_ORIGIN}/v1/command/reconciliation/${id}/resolve`, {
    method: "POST",
    headers,
    credentials: "include",
    body: JSON.stringify({ action }),
  });
  const text = await res.text();
  const json = text ? (JSON.parse(text) as { data?: unknown; error?: { message?: string } }) : {};
  if (!res.ok) throw new Error(json.error?.message ?? "Request failed");
  return json.data;
}
